import React from 'react'
import { ReactComponent as Icon } from '../../assets/svg/information-fill.svg'

interface ErrorFormInterface {
  isShow: boolean
  message?: string
  className?: string
}

const ErrorForm = ({ isShow, message, className }: ErrorFormInterface) => (
  <>
    {isShow && (
      <div
        className={`flex w-full items-center justify-start gap-2 rounded-md border border-solid border-[#D72638] bg-[#FAE4E6] px-2 py-2 text-[12px] font-semibold leading-[22px] ${className}`}
      >
        <Icon />
        {message}
      </div>
    )}
  </>
)

export default ErrorForm
